import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/common/ui/Button";
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  SelectInput,
  TextAreaInput,
} from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../_helpers";
import {
  staffRequestAction,
  authActions,
  masterActions,
  facilityAction,
} from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { createStaffRequestFormSchema } from "../../validation/staffRequestSchema";
import { StoredProcedures } from "../../_helpers/enumerator";
import { useLocation } from "react-router-dom";
import { getCurrentDate, getCurrentTime } from "../../utils/formatTime";
import { getStoredValue } from "../../_helpers/storagehelper";

function CreateStaffRequest() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { initiateOptions, ReplyMode } = useSelector(
    (state) => state.dropdownOptions
  );
  const {
    messageTypeList,
    messageTypeListForMessageToInmateList,
    GetInmateFullNameList,
    inmateList,
    newFormResponse,
    InsertRequestForumMGUserThreadResponse,
    loading,
  } = useSelector((state) => state.staffRequest);

  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const [touchedFields, setTouchedFields] = useState({});

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ManagementUserID } = useSelector((x) => x?.auth?.user);

  const loggedUser = getStoredValue("user")?.ManagementUserID;

  const createFormSource = location?.state
    ? location?.state?.createFormSource
    : "";

  const prevFacilityCodeRef = useRef(facilityCode);

  const [staffRequestForm, setStaffRequestForm] = useState({
    requestFormTypeID: 0,
    facilityID: facilityCode,
    facilityCode: "",
    isSingleInmate: 0,
    typ_RequestForumThreadMGUserInsert: [],
    messageType: "",
    podCode: "",
    managementUserID: loggedUser,
    closedStatus: 0,
    formPostBody: "",
    // pdfAttachPath: "",
    forumThreadTitle: "",
    postType: 1,
  });
  const [errorMessage, setErrorMessage] = useState({});
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);


  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      facilityAction?.GetFacilityStaffReqInfo({
        facilityID: facilityCode,
      })
    );
  }, []);

  useEffect(() => {
    if (inmateList?.length > 0) {
      dispatch(staffRequestAction?.updateInmateList([]));
    }
  }, []);

  // IOS Dropdown onchange and onblur Validation message issue.
  useEffect(() => {
    if (touchedFields.requestFormTypeID) {
      handleValidation(null, "requestFormTypeID");
    }
  }, [staffRequestForm?.requestFormTypeID]);

  useEffect(() => {
    if (touchedFields.typ_RequestForumThreadMGUserInsert) {
      handleValidation(null, "typ_RequestForumThreadMGUserInsert");
    }
  }, [staffRequestForm?.typ_RequestForumThreadMGUserInsert]);

  useEffect(() => {
    if (
      prevFacilityCodeRef.current !== facilityCode &&
      createFormSource === "staffRequestList"
    ) {
      history.navigate("/Admin/StaffRequestList");
    }

    if (
      prevFacilityCodeRef.current !== facilityCode &&
      createFormSource === "messageToInmate"
    ) {
      history.navigate("/Admin/StaffRequestList/MessageToInmate");
    }
    if (facilityCode === 0 && createFormSource === "messageToInmate") {
      history.navigate("/Admin/StaffRequestList");
    }
  }, [facilityCode]);

  useEffect(() => {
    switch (newFormResponse?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.RequestForumMGUserThreadInsert,
            UserAction: `Messaged to Inmate`,
          })
        );
        if (staffRequestForm?.isSingleInmate === 0) {
          showToastNotification(
            "Your message submitted successfully",
            "success"
          );
        } else {
          showToastNotification(
            `Your messages with ${staffRequestForm?.typ_RequestForumThreadMGUserInsert?.length} Inmates Submitted Successfully.`,
            "success"
          );
          //
        }
        history.navigate("/Admin/StaffRequestList");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [newFormResponse]);

  useEffect(() => {
    switch (InsertRequestForumMGUserThreadResponse?.IsSucceed) {
      case 1:
        if (staffRequestForm?.isSingleInmate === 0) {
          showToastNotification(
            "Your message submitted successfully",
            "success"
          );
        } else {
          showToastNotification(
            `Your messages with ${staffRequestForm?.typ_RequestForumThreadMGUserInsert?.length} Inmates Submitted Successfully.`,
            "success"
          );
          //
        }
        history?.navigate("/Admin/StaffRequestList/MessageToInmate");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -1:
        showToastNotification(`Operation Failed`, "error");
        break;

      default:
        break;
    }
  }, [InsertRequestForumMGUserThreadResponse]);

  useEffect(() => {
    if (createFormSource === "staffRequestList") {
      getMessageType(); //messageTypeList
    }

    if (createFormSource === "messageToInmate") {
      getMessageTypeForMessageToInmate(); //for message type
      GetInmateFullName(); //for inmate list
    }
  }, [createFormSource]);

  const getMessageType = () => {
    dispatch(
      staffRequestAction?.getMessageType({
        ManagementUserID: ManagementUserID,
        FacilityCode: facilityCode,
      })
    );
  };

  const getMessageTypeForMessageToInmate = () => {
    dispatch(
      staffRequestAction?.getMessageTypeForMessageToInmate({
        FacilityCode: facilityCode,
      })
    );
  };

  const GetInmateFullName = () => {
    dispatch(
      staffRequestAction?.GetInmateFullNameWithID({
        FacilityCode: facilityCode,
      })
    );
  };

  const handlesingleMultiChange = (e) => {
    setTouchedFields((prev) => ({
      ...prev,
      typ_RequestForumThreadMGUserInsert: false,
    }));
    delete errorMessage.typ_RequestForumThreadMGUserInsert;
    const { name, value } = e?.target;

    if (createFormSource === "messageToInmate") {
      const ResetCheckBox = chooseInmateDrpDown.map((item) => ({
        ...item,
        isActive: false,
      }));
      dispatch(staffRequestAction?.updateFullNameList(ResetCheckBox));
    }

    if (createFormSource === "staffRequestList") {
      const ResetCheckBox = inmateList.map((item) => ({
        ...item,
        isActive: false,
      }));
      dispatch(staffRequestAction?.updateInmateList(ResetCheckBox));
    }
    setStaffRequestForm({
      ...staffRequestForm,
      [name]: parseInt(value),
      typ_RequestForumThreadMGUserInsert: [],
    });
    setErrorMessage((prev) => ({
      ...prev,
      typ_RequestForumThreadMGUserInsert: "",
    }));
  };

  const handleChange = (e, select) => {
    const { name, value, type, files, checked } = e?.target;
    const errorList = { ...errorMessage };
    delete errorList[name];
    setErrorMessage(errorList);

    if (type === "file" && files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "Please upload PDF Document.",
      }));
      const data = { ...staffRequestForm };
      data["file"] = { type: "", size: 0 };
      data["fileType"] = "";
      data["fileSize"] = 0;
      setStaffRequestForm(data);
      return;
    }

    if (type === "file" && files?.length > 0) {
      const fileType = files?.[0]?.type;
      const fileSize = files?.[0]?.size;
      if (fileSize > MAX_FILE_SIZE) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "File size should not exceed 20MB.",
        }));
      }
      if (fileType !== "application/pdf") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please select PDF Document.",
        }));
        const data = { ...staffRequestForm };
        data["file"] = { type: "", size: 0 };
        data["fileType"] = fileType;
        data["fileSize"] = 0;
        // dispatch(staffRequestAction?.updateRequestFormInfoPayloadData(data));
        setStaffRequestForm(data);
        return;
      }
      // setErrorMessage({});
      const reader = new FileReader();
      reader.onloadend = () => {
        let formData = { ...staffRequestForm };
        const fileName = files[0]?.name;
        const lastIndex = fileName?.lastIndexOf(".");
        const removedExtensionTxt = [...fileName]
          .splice(0, lastIndex)
          .toString();
        const removeWhitSpace = removedExtensionTxt.replace(
          /[+\-\/,?*:;<>@#$%^&!~\s]/g,
          ""
        );
        const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join(""); //retutn only 100 characters
        const currentDate = getCurrentDate()?.split("/").join("");
        const currentTime = getCurrentTime().split(":").join("");
        const now = new Date();
        // const timestamp = now.getFullYear().toString() +
        //   String(now.getMonth() + 1).padStart(2, "0") +
        //   String(now.getDate()).padStart(2, "0") +
        //   String(now.getHours()).padStart(2, "0") +
        //   String(now.getMinutes()).padStart(2, "0") +
        //   String(now.getSeconds()).padStart(2, "0");
        formData["file"] = reader.result.split(",")[1];
        formData["fileType"] = files?.[0]?.type;
        formData["fileSize"] = files?.[0]?.size;
        formData["filename"] = removedExtraTxt;
        setStaffRequestForm(formData);
      };
      reader.readAsDataURL(files[0]);
    }

    if (type === "radio") {
      //clear value when change
      const searchData = { ...staffRequestForm };
      searchData.formPostBody = "";
      searchData.file = "";
      searchData["fileType"] = "";
      searchData["fileSize"] = 0;
      searchData["filename"] = "";
      searchData[name] = parseInt(value);
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = "";
      }
      const errorList = { ...errorMessage };
      // delete errorList[name];
      delete errorList.formPostBody;
      delete errorList.file;

      setErrorMessage(errorList);
      setStaffRequestForm(searchData);
      return;
    }
    if (/^\s/.test(value)) return;
    setStaffRequestForm({
      ...staffRequestForm,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };

  const handleSearchReset = () => {
    setErrorMessage({});
    setTouchedFields((prev) => ({
      ...prev,
      typ_RequestForumThreadMGUserInsert: false,
      requestFormTypeID: false,
    }));
    const resetSearch = {
      requestFormTypeID: 0,
      facilityID: facilityCode,
      isSingleInmate: 0,
      typ_RequestForumThreadMGUserInsert: [],
      messageType: "",
      podCode: "",
      managementUserID: loggedUser,
      closedStatus: 0,
      formPostBody: "",
      // pdfAttachPath: "",
      file: "",
      forumThreadTitle: "",
      postType: 1,
    };
    setStaffRequestForm(resetSearch);
    if (createFormSource === "staffRequestList") {
      if (inmateList?.length > 0) {
        dispatch(staffRequestAction?.updateInmateList([]));
      }
      return;
    }
    if (createFormSource === "messageToInmate") {
      const ResetCheckBox = chooseInmateDrpDown.map((item) => ({
        ...item,
        isActive: false,
      }));
      dispatch(staffRequestAction?.updateFullNameList(ResetCheckBox));
    }
  };

  // const handleInmateChange = (e, variant) => {
  //   if (variant === "single") {
  //     setStaffRequestForm({
  //       ...staffRequestForm,
  //       typ_RequestForumThreadMGUserInsert: [{ inmateID: e?.value }],
  //     });
  //     return;
  //   } else {
  //     const inmateListData = [
  //       ...staffRequestForm?.typ_RequestForumThreadMGUserInsert,
  //     ];
  //     const { value, checked } = e?.target;

  //     //update checkbox for ui
  //     const arrList =
  //       createFormSource === "staffRequestList"
  //         ? inmateList
  //         : GetInmateFullNameList;

  // const updateCheckbox = arrList?.map((item, index) => {
  //   if (item?.value === parseInt(value)) {
  //     return { ...item, isActive: checked };
  //   }
  // if (parseInt(value) === 0) {
  //   return { ...item, isActive: checked };
  // }
  //   return item;
  // });
  // if (createFormSource === "staffRequestList") {
  //   dispatch(staffRequestAction?.updateInmateList(updateCheckbox));
  // }

  // if (createFormSource === "messageToInmate") {
  //   dispatch(staffRequestAction?.updateFullNameList(updateCheckbox));
  // }

  //     if (checked) {
  //       if (parseInt(value) === 0) {
  //         const updatedList = updateCheckbox
  //           ?.filter((item) => item?.value !== 0)
  //           ?.map((item) => ({ inmateID: item?.value }));

  //         setStaffRequestForm({
  //           ...staffRequestForm,
  //           typ_RequestForumThreadMGUserInsert: updatedList,
  //         });
  //         return;
  //       }
  //       inmateListData?.push({ inmateID: value });
  // setStaffRequestForm({
  //   ...staffRequestForm,
  //   typ_RequestForumThreadMGUserInsert: inmateListData,
  // });
  //     } else {
  //       if (parseInt(value) === 0) {
  //         //select all
  //         setStaffRequestForm({
  //           ...staffRequestForm,
  //           typ_RequestForumThreadMGUserInsert: [],
  //         });
  //         return;
  //       }
  //       const removedArr = staffRequestForm[
  //         "typ_RequestForumThreadMGUserInsert"
  //       ]?.filter((item, index) => item?.inmateID !== value);
  //       setStaffRequestForm({
  //         ...staffRequestForm,
  //         typ_RequestForumThreadMGUserInsert: removedArr,
  //       });
  //     }
  //   }
  // };

  const handleSingleInmateChange = (e) => {
    setTouchedFields((prev) => ({
      ...prev,
      typ_RequestForumThreadMGUserInsert: true,
    }));
    setStaffRequestForm({
      ...staffRequestForm,
      typ_RequestForumThreadMGUserInsert:
        e?.value !== 0 && e?.value !== undefined
          ? [{ inmateID: e?.value }]
          : [],
    });
    setErrorMessage((prev) => ({
      ...prev,
      typ_RequestForumThreadMGUserInsert: "",
    }));
    return;
  };

  const handleMultiInmateChange = (e) => {
    const { checked, value } = e?.target;

    const errorList = { ...errorMessage };
    delete errorList["typ_RequestForumThreadMGUserInsert"];
    setErrorMessage(errorList);
    const inmateListData =
      createFormSource === "staffRequestList"
        ? inmateList
        : GetInmateFullNameList;

    const arrWithCheckedElament = inmateListData?.map((item) => {
      if (item?.value === parseInt(value)) {
        return { ...item, isActive: checked };
      }
      if (parseInt(value) === 0) {
        return { ...item, isActive: checked };
      }
      return item;
    });

    //check all checkbox is checked or not
    const isallChecked = arrWithCheckedElament
      ?.filter((item) => {
        return item?.value !== 0;
      })
      .every((item) => item?.isActive);

    const updateSelectAll = [...arrWithCheckedElament]?.map((item) => {
      if (item?.value === 0) {
        return { ...item, isActive: isallChecked };
      }
      return item;
    });

    if (createFormSource === "staffRequestList") {
      dispatch(staffRequestAction?.updateInmateList(updateSelectAll));
    }

    if (createFormSource === "messageToInmate") {
      dispatch(staffRequestAction?.updateFullNameList(updateSelectAll));
    }

    const filterInmateList = arrWithCheckedElament?.filter(
      (item) => item?.isActive === true && item?.value > 0
    );
    const transformedArr = filterInmateList.map(({ value }) => ({
      inmateID: value,
    }));
    setStaffRequestForm({
      ...staffRequestForm,
      typ_RequestForumThreadMGUserInsert: transformedArr,
    });
  };
  const handleNavigate = () => {
    if (createFormSource === "messageToInmate") {
      history?.navigate("/Admin/StaffRequestList/MessageToInmate");
    }
    if (createFormSource === "staffRequestList") {
      history?.navigate("/Admin/StaffRequestList");
    }
  };

  const handleValidation = (e, name) => {
    // const requestData = { ...staffRequestForm };
    // const file = { type: requestData?.fileType, size: requestData?.fileSize };
    // requestData.file = file;
    // const { error } = createStaffRequestFormSchema(requestData);
    // if (error?.details) {
    //   const fieldError = error.details.find((e) => e.path.toString() === name);
    // setErrorMessage((prev) => ({
    //   ...prev,
    //   [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
    // }));
    //   const element = document.querySelector(`[name="${name}"]`);
    //   if (element) {
    //     if (fieldError) {
    //       element.classList.add("input-error");
    //     } else {
    //       element.classList.remove("input-error");
    //     }
    //   }
    // } else {
    //   setErrorMessage((prev) => ({
    //     ...prev,
    //     [name]: "",
    //   }));
    //   const element = document.querySelector(`[name="${name}"]`);
    //   if (element) {
    //     element.classList.remove("input-error");
    //   }
    // }
    const requestData = { ...staffRequestForm };
    // const pdfAttachPath = {
    //   type: requestData?.fileType,
    //   size: requestData?.fileSize,
    // };
    const file = {
      type: requestData?.fileType,
      size: requestData?.fileSize,
    };
    // requestData.pdfAttachPath = pdfAttachPath;
    requestData.file = file;
    const { error } = createStaffRequestFormSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "",
      }));
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const handleSubmitForm = (e) => {
    e?.preventDefault();
    const requestData = { ...staffRequestForm };
    // const pdfAttachPath = {
    //   type: requestData?.fileType,
    //   size: requestData?.fileSize,
    // };
    const file = {
      type: requestData?.fileType,
      size: requestData?.fileSize,
    };
    // requestData.pdfAttachPath = pdfAttachPath;
    requestData.file = file;
    // GetFacilityStaffReqInfoResponse?.FacilityName
    const { error } = createStaffRequestFormSchema(requestData);
    setErrorMessage({});
    if (error?.details) {
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });

      return;
    }

    const data = { ...staffRequestForm };
    data.facilityCode = GetFacilityStaffReqInfoResponse?.FacilityName;
    if (createFormSource === "staffRequestList") {
      dispatch(staffRequestAction?.createStaffRequestForm(data));
    }

    if (createFormSource === "messageToInmate") {
      dispatch(staffRequestAction?.InsertRequestForumMGUserThread(data));
    }
  };

  const chooseInmateDrpDown =
    createFormSource === "staffRequestList"
      ? inmateList
      : GetInmateFullNameList;

  const handleMessageType = (e) => {
    setTouchedFields((prev) => ({
      ...prev,
      requestFormTypeID: true,
    }));
    const search = { ...staffRequestForm };
    if (createFormSource === "staffRequestList") {
      search.typ_RequestForumThreadMGUserInsert = [];
      dispatch(staffRequestAction?.updateInmateList([]));
    }
    search["requestFormTypeID"] = e?.value;
    search.forumThreadTitle = e?.label;
    search.messageType = e?.label;
    setStaffRequestForm(search);
    if (e?.value > 0 && createFormSource === "staffRequestList") {
      dispatch(
        staffRequestAction?.getInmateList({
          formID: e?.value,
          FacilityCode: facilityCode,
        })
      );
    }
    setErrorMessage((prev) => ({
      ...prev,
      requestFormTypeID: "",
    }));
    return;
  };

  if (loading || facilityLoader) return <CustomLoader />;

  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100">
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        {/* <h2 className=" mb-4 text-color">INITIATE MESSAGE TO INBOX</h2> */}
        <h2 className=" mb-4 text-color">
          {createFormSource === "staffRequestList"
            ? "INITIATE REQUEST FORM"
            : "INITIATE MESSAGE TO INBOX"}
        </h2>
        <Button
          label="Back"
          type="button"
          icon={"fa-solid fa-angle-left"}
          status="primary"
          onClick={() => {
            handleNavigate();
          }}
        />
      </div>
      <form
        onSubmit={(e) => {
          handleSubmitForm(e);
        }}
      >
        <div className="d-flex flex-wrap flex-column ">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-4">
              <div className="form-floating mb-3">
                <SelectInput
                  name="requestFormTypeID"
                  label="Message Type"
                  options={
                    createFormSource === "staffRequestList"
                      ? messageTypeList
                      : messageTypeListForMessageToInmateList
                  }
                  handleChange={(e) => handleMessageType(e)}
                  value={staffRequestForm?.requestFormTypeID}
                  errorMessage={errorMessage}
                  required
                  isClearable={staffRequestForm?.requestFormTypeID}
                // handleBlur={(e) => {
                //   handleValidation(e, "requestFormTypeID");
                // }}
                />
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-4">
              <div className="form-floating mt-4">
                <RadioInput
                  name="isSingleInmate"
                  id="isSingleInmate"
                  options={initiateOptions}
                  selectedValue={staffRequestForm?.isSingleInmate}
                  handleChange={(e) => handlesingleMultiChange(e)}
                // errorMessage={errorMessage}
                // selectedValue={facilityInformationData?.InmateUploadType}
                />
              </div>
            </div>
            {staffRequestForm?.isSingleInmate === 0 ? (
              <div className="col-sm-6 col-lg-4 col-md-12">
                <div className="form-floating mb-3">
                  <SelectInput
                    name="typ_RequestForumThreadMGUserInsert"
                    label="Choose Inmate"
                    options={
                      createFormSource === "staffRequestList"
                        ? inmateList
                        : GetInmateFullNameList
                    }
                    value={
                      staffRequestForm?.typ_RequestForumThreadMGUserInsert
                        ?.length > 0
                        ? staffRequestForm
                          ?.typ_RequestForumThreadMGUserInsert?.[0]?.inmateID
                        : 0
                    }
                    handleChange={(e) => handleSingleInmateChange(e)}
                    errorMessage={errorMessage}
                    required
                    isClearable={
                      staffRequestForm?.typ_RequestForumThreadMGUserInsert
                        ?.length > 0
                        ? staffRequestForm
                          ?.typ_RequestForumThreadMGUserInsert?.[0]?.inmateID
                        : false
                    }
                  // handleBlur={(e) => {
                  //   handleValidation(e, "typ_RequestForumThreadMGUserInsert");
                  // }}
                  />
                </div>
              </div>
            ) : (
              <div
                className="col-sm-6 col-md-6 col-lg-4"
                style={{ height: "200px" }}
              >
                <label className="form-label col-form-label w-100 font-size-15 form-label-custom-visible">
                  Choose Inmate <span className="text-danger">*</span>
                </label>
                <div
                  className={
                    " p-2 rounded overflow-auto " +
                    (staffRequestForm?.isSingleInmate === 1 &&
                      errorMessage["typ_RequestForumThreadMGUserInsert"]
                      ? "input-error"
                      : "border")
                  }
                  style={{ height: "80%" }}
                >
                  {chooseInmateDrpDown?.map((item, i) => {
                    return (
                      <div key={i}>
                        <CheckBoxInput
                          label={item?.label}
                          id={item?.label}
                          value={item?.value}
                          handleClick={(e) => handleMultiInmateChange(e)}
                          // checked={inmateList[i]?.isActive}
                          checked={
                            createFormSource === "staffRequestList"
                              ? inmateList?.[i]?.isActive
                              : GetInmateFullNameList?.[i]?.isActive
                          }
                          handleBlur={(e) => {
                            handleValidation(
                              e,
                              "typ_RequestForumThreadMGUserInsert"
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                {staffRequestForm?.isSingleInmate === 1 &&
                  errorMessage?.typ_RequestForumThreadMGUserInsert !== "" && (
                    <div class="text-danger fw-700 fs-6">
                      {errorMessage?.typ_RequestForumThreadMGUserInsert}
                    </div>
                  )}
              </div>
            )}



            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <RadioInput
                  label="Reply Mode"
                  name="postType"
                  id="postType"
                  options={ReplyMode}
                  handleChange={(e) => handleChange(e)}
                  // errorMessage={errorMessage}
                  selectedValue={staffRequestForm?.postType}
                  required
                />
              </div>
            </div>

            <div className="col-sm-6 col-md-8">
              <div className="form-floating mb-3">
                {(staffRequestForm?.postType === 1 ||
                  staffRequestForm?.postType === 3) && (
                    <TextAreaInput
                      name="formPostBody"
                      id="formPostBody"
                      label="Description"
                      value={staffRequestForm?.formPostBody}
                      placeholder="Description"
                      handleChange={(e) => handleChange(e)}
                      errorMessage={errorMessage}
                      maxLength={2000}
                      required
                      handleBlur={(e) => {
                        handleValidation(e, "formPostBody");
                      }}
                      rows={3}
                    />
                  )}
                {(staffRequestForm?.postType === 2 ||
                  staffRequestForm?.postType === 3) && (
                    <FileInput
                      acceptFormat=".pdf"
                      // name="pdfAttachPath"
                      name="file"
                      id="fileInput"
                      handleFileChange={(e) => handleChange(e)}
                      errorMessage={errorMessage}
                    />
                  )}
              </div>
            </div>

            <div className="col-md-4"></div>

            <div className="col-sm-6 col-md-8">
              <div className="form-floating mb-3">
                <CheckBoxInput
                  label="Closed"
                  name="closedStatus"
                  id="closedStatus"
                  checked={staffRequestForm?.closedStatus}
                  handleClick={(e) => handleChange(e)}
                // checked={facilityInformationData?.IsPhotoAccess === 1}
                // errorMessage={errorMessage}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap mt-3 mb-5">
          <Button
            variant="primary"
            className="me-2"
            label="Submit"
            type="submit"
            status="success"
            icon={"fa-solid fa-floppy-disk"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={() => handleSearchReset()}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    </div>
  );
}

export default React.memo(CreateStaffRequest);
